import React from 'react';
import { formatCurrency } from '../utils/format';
import {
  customerTotalFromCafePrice,
  platformFeeFromCafePrice,
} from '../utils/menuPlatformPricing';

const readOnlyInputClass =
  'w-full px-3 py-2 border border-gray-200 rounded bg-gray-100 text-gray-600 cursor-not-allowed';

type MenuPriceFieldsProps = {
  cafePrice: number;
  onCafePriceChange: (value: number) => void;
  platformFeePct: number;
  imageUrl?: string;
  onImageUrlChange?: (value: string) => void;
  showImageUrl?: boolean;
};

export default function MenuPriceFields({
  cafePrice,
  onCafePriceChange,
  platformFeePct,
  imageUrl = '',
  onImageUrlChange,
  showImageUrl = true,
}: MenuPriceFieldsProps) {
  const feeJod = platformFeeFromCafePrice(cafePrice, platformFeePct);
  const totalJod = customerTotalFromCafePrice(cafePrice, platformFeePct);
  const pctPercent = String(Math.round(platformFeePct * 1000) / 10);

  return (
    <>
      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-1">Your café price (JOD)</label>
        <input
          type="number"
          step="0.01"
          min={0.1}
          className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-amber-500"
          value={cafePrice}
          onChange={(e) => onCafePriceChange(Number(e.target.value))}
        />
        <p className="text-xs text-gray-500 mt-1">
          What you set before Qahwahub&apos;s platform fee. Customers pay the total below.
        </p>
      </div>
      {showImageUrl && onImageUrlChange && (
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1">Image URL (optional)</label>
          <input
            type="url"
            className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-amber-500"
            value={imageUrl}
            onChange={(e) => onImageUrlChange(e.target.value)}
            placeholder="https://..."
          />
        </div>
      )}
      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-1">
          Qahwahub platform fee ({pctPercent}%)
        </label>
        <div className="flex gap-2 items-center mb-2">
          <input
            type="text"
            readOnly
            disabled
            className="w-24 px-3 py-2 border border-gray-200 rounded bg-gray-100 text-gray-600 cursor-not-allowed"
            value={pctPercent}
            aria-label="Qahwahub platform fee percent"
          />
          <span className="text-sm text-gray-500">%</span>
        </div>
        <input
          type="text"
          readOnly
          disabled
          className={readOnlyInputClass}
          value={formatCurrency(feeJod)}
          aria-label="Qahwahub platform fee amount"
        />
      </div>
      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-1">Customer total (JOD)</label>
        <input
          type="text"
          readOnly
          disabled
          className={readOnlyInputClass}
          value={formatCurrency(totalJod)}
          aria-label="Customer total price"
        />
        <p className="text-xs text-gray-500 mt-1">Shown in the app — café price + platform fee.</p>
      </div>
    </>
  );
}
